<script setup>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'dashboard/composables/store';
import { useAlert } from 'dashboard/composables';

import NextButton from 'dashboard/components-next/button/Button.vue';

const emit = defineEmits(['close']);

const { t } = useI18n();
const store = useStore();

const name = ref('');
const description = ref('');
const isCreating = ref(false);

const isInvalid = computed(() => !name.value.trim());

const onClose = () => emit('close');

const createFunnel = async () => {
  if (isInvalid.value) return;
  isCreating.value = true;
  try {
    await store.dispatch('funnels/createFunnel', {
      name: name.value.trim(),
      description: description.value.trim(),
    });
    useAlert(t('FUNNELS.SETTINGS.CREATE.SUCCESS'));
    onClose();
  } catch (error) {
    useAlert(t('FUNNELS.SETTINGS.CREATE.ERROR'));
  } finally {
    isCreating.value = false;
  }
};
</script>

<template>
  <div class="flex flex-col h-auto overflow-auto">
    <woot-modal-header
      :header-title="t('FUNNELS.SETTINGS.CREATE.TITLE')"
      :header-content="t('FUNNELS.SETTINGS.CREATE.DESC')"
    />
    <form class="flex flex-wrap mx-0" @submit.prevent="createFunnel">
      <woot-input
        v-model="name"
        class="w-full"
        :label="t('FUNNELS.SETTINGS.FORM.NAME.LABEL')"
        :placeholder="t('FUNNELS.SETTINGS.FORM.NAME.PLACEHOLDER')"
      />
      <woot-input
        v-model="description"
        class="w-full"
        :label="t('FUNNELS.SETTINGS.FORM.DESCRIPTION.LABEL')"
        :placeholder="t('FUNNELS.SETTINGS.FORM.DESCRIPTION.PLACEHOLDER')"
      />
      <div class="flex items-center justify-end w-full gap-2 px-0 py-2">
        <NextButton
          faded
          slate
          type="reset"
          :label="t('FUNNELS.SETTINGS.FORM.CANCEL')"
          @click.prevent="onClose"
        />
        <NextButton
          type="submit"
          :label="t('FUNNELS.SETTINGS.FORM.CREATE')"
          :disabled="isInvalid || isCreating"
          :is-loading="isCreating"
        />
      </div>
    </form>
  </div>
</template>
